import React from 'react';
import {
  titleUI,
  currencyUI,
} from '~/platform/forms-system/src/js/web-component-patterns';

const uiSchema = {
  ...titleUI('Enter the cost of the prep course including any mandatory fees'),
  'ui:description': () => (
    <>
      <p>
        Enter the cost of the prep course you completed or are currently
        enrolled in. You can only list one prep course per request, including
        any mandatory fees. (We can only reimburse you for required course
        fees.) We have no authority to reimburse you for any optional costs
        related to the prep course process.
      </p>
      <p>
        Fees that VA has no authority to reimburse include fees to take
        pre-tests, or other costs or fees for optional items that are not
        required to take an approved Prep Course.
      </p>
    </>
  ),
  prepCourseCost: {
    ...currencyUI({
      title: 'Prep course cost including any mandatory fees',
      hint: 'You will need to upload a receipt supporting the amount entered on this page.',
      errorMessages: {
        required: 'Enter prep course cost',
      },
    }),
  },
};

const schema = {
  type: 'object',
  properties: {
    prepCourseCost: {
      type: 'string',
      pattern: '^\\d+(\\.\\d{1,2})?$',
    },
  },
  required: ['prepCourseCost'],
};

export { schema, uiSchema };
